const Users = () => <h2>User Management is not available</h2>;
export default Users;
